<template>
    <div class="tw-flex tw-flex-col lg:tw-flex-row tw-pt-3 lg:tw-pt-6 tw-pb-12 tw-border-0 md:tw-border-t md:tw-border-b md:tw-border-dark-grey">
        <div class="tw-flex tw-flex-col tw-w-full lg:tw-w-1/6 tw-border-b tw-border-dark-grey lg:tw-border-0 tw-mb-10 lg:tw-mb-0">
            <div class="h7 pb-2">Crew Alert List</div>
        </div>
        <div class="tw-flex tw-flex-col tw-w-full lg:tw-w-5/6 tw-border-b tw-border-dark-grey md:tw-border-0">
            <v-btn @click="$inertia.visit(route('crewalerts.show.new'))" class="main-btn tw-mb-4 tw-w-72">New Crew Alert</v-btn>
            <crew-alerts-filters
                v-show="!pdf_view"
                v-model="filters"
                :constants="constants"
                :valuelists="valuelists"
            />
            <div class="tw-flex tw-flex-row tw-w-full tw-justify-between tw-items-center tw-pt-2 tw-pb-1 tw-border-b tw-border-t tw-border-dark-grey" v-show="num_records_filtered">
                <div class="tw-text-xl tw-font-light">{{ num_records_filtered }} Crew Alerts</div>
            </div>
            <smart-table
                id="crew_alerts_list"
                endpoint="crewalerts.list"
                :items="items"
                :options_payload="{within_two_weeks:true}"
                :hide-default-footer="pdf_view"
                :headers="headers"
                :search="filters.search"
                :multi-sort="true"
                :items-per-page="getDefaultItemsPerPage()"
                :footer-props="{
            'items-per-page-options': getDefaultItemsPerPageOptions()
        }"
                flat
                ref="crew_alerts_list"
                @fetch-complete="receivedTableDataUpdate"
            >
                <template v-slot:item.date_issued="{ isMobile, item, header, value, index}">
                    <div>
                        <a class="underlined_link" @click.prevent="goToDetails(item)">{{ $root.getAsIsoDate(value) }} at {{ item.time_issued }}</a>
                    </div>
                    <div>
                        By: {{ item.issuer?.first_name }} {{ item.issuer?.last_name }}
                    </div>
                </template>

                <template v-slot:item.title_functions.name="{ isMobile, item, header, value, index}">
                    <div>{{ item.title_function?.name }}</div>
                </template>

                <template v-slot:item.date_required_temp="{ isMobile, item, header, value, index}">
                    <div>{{ item.date_required_temp }}</div>
                </template>

                <template v-slot:item.productions.name="{ isMobile, item, header, value, index}">
                    <div>{{ item.production?.name }}</div>
                </template>

                <template v-slot:item.provinces.name="{ isMobile, item, header, value, index}">
                    <div>{{ item.province?.name }}</div>
                </template>

            </smart-table>
        </div>
    </div>
</template>

<script>
    import SmartTable from "@/Generic/SmartTable";
    import AppLayoutSidebarNav from "@/Layouts/AppLayoutSidebarNav.vue";
    import CrewAlertsFilters from "@/Pages/ExternalPages/CrewAlertsFilters.vue";

    export default {
        name: "CrewAlertsIndex",
        layout: (h, page) => {
            return h(AppLayoutSidebarNav, [
                page
            ])
        },
        components: {
            CrewAlertsFilters,
            SmartTable,
        },
        remember: {
            data: [
                'items'
            ]
        },
        props: {
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'valuelists': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'items': {          // Will optionally accept a hardcoded list of items instead of getting smart table to fetch them
                type: Array,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'pdf_view': {
                type: Boolean,
                required: false,
                default: function () {
                    return false
                }
            },
        },
        data() {
            return {
                constant: this.constants,
                filters: {
                    date_issued: null,
                    title_function: null,
                    province: null,
                    date_required_temp: null,
                    production: {name:null},
                },
                fetch_data_response: null,
            }
        },
        computed: {
            headers() {
                return [
                    {value: 'date_issued',          text: 'Date & Time Issued', align: `start`,     sortable: true,    filterable: true,   search: this?.filters?.date_issued },
                    {value: 'title_function.id',    text: 'Job Category ID',    align: ` d-none`,   sortable: true,    filterable: true,   search: this?.filters?.title_function },
                    {value: 'title_functions.name', text: 'Job Category',       align: `start`,     sortable: true,    filterable: false },
                    {value: 'date_required_temp',   text: 'Date Required',      align: `start`,     sortable: true,    filterable: true,   search: this?.filters?.date_required_temp },
                    {value: 'productions.name',     text: 'Production',         align: `start`,     sortable: true,    filterable: true,   search: this?.filters?.production?.name },
                    {value: 'province.id',          text: 'Province ID',        align: ` d-none`,   sortable: true,    filterable: true,   search: this?.filters?.province },
                    {value: 'provinces.name',       text: 'Province',           align: `start`,     sortable: true,    filterable: false },
                ]
            },
            filters_used() {
                let filters_used = Object.keys(this.filters).filter(filter => (!!this.filters[filter] && this.filters[filter].length))
                if (filters_used?.length === 4) return "All"
                if (!filters_used || filters_used.length === 0) return ""
                return filters_used?.join(", ").toProperCase()
            },
            num_records_total() {
                return this.fetch_data_response?.data?.recordsTotal
            },
            num_records_filtered() {
                return this.fetch_data_response?.data?.recordsFiltered || this.items?.length
            },
            values_regions() {
                if (this?.constants?.MEMBER_REGIONS) {
                    return Object.values(this.constants?.MEMBER_REGIONS)
                }
                return []
            },
            values_categories() {
                if (this?.valuelists?.TITLE_FUNCTIONS) {
                    return Object.values(this.valuelists?.TITLE_FUNCTIONS)
                }
                return []
            },
            values_skills() {
                if (this?.valuelists?.SKILLS_GROUPED) {
                    return Object.values(this.valuelists?.SKILLS_GROUPED)
                }
                return []
            },
        },
        methods: {
            receivedTableDataUpdate(response) {
                this.fetch_data_response = response
            },
            getNameForDisplay(record) {
                if (!!record?.last_name && !!record?.first_name) {
                    return `${record.last_name}, ${record.first_name}`
                }
                return record?.last_name || record?.first_name
            },
            getFullName(record) {
                if (!!record?.last_name && !!record?.first_name) {
                    return `${record.first_name} ${record.last_name}`
                }
                return record?.last_name || record?.first_name
            },
            getDefaultItemsPerPage() {
                return this.pdf_view ? -1 : 20
            },
            getDefaultItemsPerPageOptions() {
                return this.pdf_view ? [-1] : [5, 10, 20, 30]
            },
            goToDetails(item) {
                this.$inertia.visit(route(`crewalerts.show`, item).url())
            }
        }
    }
</script>

<style>
.row-pointer tbody tr {
    cursor: pointer;
}

td>div:empty {
    display:none !important;
    visibility: hidden !important;
    min-height: unset !important;
}

.underlined_link {
    color: #0000EE !important;
    text-decoration: underline;
}

</style>
